/*=========================================================================================
  File Name: moduleImmo.js
  Description: Immo Module
==========================================================================================*/

import state from './moduleImmoState.js';
import mutations from './moduleImmoMutations.js';
import actions from './moduleImmoActions.js';
import getters from './moduleImmoGetters.js';

export default {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
};